import React from 'react'
import { bool, string, func } from 'prop-types'
import { connect } from 'react-redux'
import MdAutorenew from 'react-icons/lib/md/autorenew'
import styled from 'styled-components'
import { toggleSidebar } from '../../../store/Actions/UiActions'

const P = styled.p`
  color: ${props => props.theme} !important;
  font-size: 11px !important;
  padding-top: 7px;
  margin: 0;
  padding-bottom: 7px;
  text-transform: capitalize;
  cursor: pointer;
`

const SearchOrLoading = ({ loading, theme, category, toggleSidebar }) =>
  loading ? (
    <MdAutorenew color="green" className="loading" />
  ) : (
    <P
      theme={theme}
      title={`Current signs category selection`}
      onClick={() => toggleSidebar(true)}
    >
      {category}
    </P>
  )

SearchOrLoading.propTypes = {
  loading: bool.isRequired,
  theme: string.isRequired,
  category: string.isRequired,
  toggleSidebar: func.isRequired,
}

const mapStateToProps = ({ signsState, spi }) => ({
  loading: signsState.loading,
  theme: spi.theme,
  category: spi.category[0],
})

const mapDispatchToProps = dispatch => ({
  toggleSidebar: value => dispatch(toggleSidebar(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchOrLoading)



// WEBPACK FOOTER //
// ./src/components/Elements/AddressBar/SearchOrLoading.jsx